import { render, staticRenderFns } from "./LabelsInfos.vue?vue&type=template&id=18524990&"
import script from "./LabelsInfos.vue?vue&type=script&lang=ts&"
export * from "./LabelsInfos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports